import {trackMenuClick, trackSearch} from './core';

const sanitizeString = (str) => {
  str = str.replace(/[^a-z0-9áéíóúñü .,_-]/gim, '');
  return str.trim();
};

const search = (query, onSearch) => {
  if (query && query.length > 0) {
    const sanitizedQuery = sanitizeString(query);
    trackSearch(sanitizedQuery);
    onSearch(encodeURI(sanitizedQuery));
  }
};

export const setupMenuItem = (element) => {
  element.addEventListener('click', () => {
    let target = element;
    while (target.hasChildNodes() && target.firstChild.tagName) {
      target = target.firstChild;
    }
    trackMenuClick(target.innerHTML.trim());
  });
};

export const setupSearchButton = (btn, input, onSearch) => {
  btn.addEventListener('click', (e) => {
    let term = input.value.trim();
    if (term.length > 0) {
      search(term, onSearch);
    }
  });
};

export const setupInputSearch = (element, onSearch) => {
  element.addEventListener('keydown', (e) => {
    if (e.isComposing || e.keyCode === 229) {
      return;
    }
    if (e.keyCode === 13) {
      let term = e.target.value.trim();
      if (term.length > 0) {
        search(term, onSearch);
      }
    }
  });
};